import {
  FETCHING_EMAIL_TEMPLATES_REQUEST,
  FETCHING_EMAIL_TEMPLATES_SUCCEDDED,
  FETCHING_EMAIL_TEMPLATES_FAILED,
  INVALIDATE_EMAIL_TEMPLATES,
  SELECTION_EMAIL_TEMPLATE,
  INVALIDATE_SELECTION_EMAIL_TEMPLATE,
  CREATING_EMAIL_TEMPLATE_REQUEST,
  CREATING_EMAIL_TEMPLATE_SUCCEDDED,
  CREATING_EMAIL_TEMPLATE_FAILED,
  UPDATING_EMAIL_TEMPLATE_REQUEST,
  UPDATING_EMAIL_TEMPLATE_SUCCEDDED,
  UPDATING_EMAIL_TEMPLATE_FAILED,
  DELETING_EMAIL_TEMPLATE_REQUEST,
  DELETING_EMAIL_TEMPLATE_SUCCEDDED,
  DELETING_EMAIL_TEMPLATE_FAILED,
  FETCHING_EMAIL_TEMPLATE_REQUEST,
  FETCHING_EMAIL_TEMPLATE_SUCCEDDED,
  FETCHING_EMAIL_TEMPLATE_FAILED,
  FETCHING_DEFAULT_EMAIL_TEMPLATE_REQUEST,
  FETCHING_DEFAULT_EMAIL_TEMPLATE_SUCCEDDED,
  FETCHING_DEFAULT_EMAIL_TEMPLATE_FAILED,
  INVALIDATE_DEFAULT_EMAIL_TEMPLATE,
  UPLOADING_MEDIA_REQUEST,
  UPLOADING_MEDIA_SUCCEEDED,
  UPLOADING_MEDIA_FAILED,
} from "../actions/actionTypes.jsx";

const initialState = {
  loading: false,
  loadMore: true,
  invalidated: true,
  currentPage: -1,
  totalPages: 0,
  recordsPerPage: 0,
  items: [],
  error: null,
  template: {
    loading: false,
    creating: false,
    error: null,
    deleting: false,
    uploading: false,
    media: {
      image: [],
      error: null,
    },
  },
  defaultTemplate: {
    loading: false,
    item: null,
    error: null,
  },
  selectedTemplate: null,
};

function emailTemplateReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_EMAIL_TEMPLATES_REQUEST:
      return Object.assign({}, state, {
        ...state,
        loading: true,
        invalidated: true,
      });

    case FETCHING_EMAIL_TEMPLATES_SUCCEDDED:
      var result = action.payload;

      var loadMore = result.currentPage <= result.totalPages;
      var records = result.records || [];
      var items = [...state.items, ...records];

      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id == y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);

      items = items.reduce((item, template) => {
        if (template.default) {
          return [template, ...item];
        }
        return [...item, template];
      }, []);

      return Object.assign({}, state, {
        ...state,
        loading: false,
        items: items,
        currentPage: result.currentPage,
        totalPages: result.totalPages,
        loadMore: loadMore,
        invalidated: false,
      });

    case FETCHING_EMAIL_TEMPLATES_FAILED:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        error: action.payload.error,
      });

    case INVALIDATE_EMAIL_TEMPLATES:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: true,
        items: [],
      });

    case SELECTION_EMAIL_TEMPLATE:
      return Object.assign({}, state, {
        ...state,
        selectedTemplate: action.payload,
      });

    case INVALIDATE_SELECTION_EMAIL_TEMPLATE:
      return Object.assign({}, state, {
        ...state,
        selectedTemplate: null,
      });

    case FETCHING_EMAIL_TEMPLATE_REQUEST:
      var id = action.payload;
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          [id]: {
            fetching: true,
          },
        },
      });

    case FETCHING_EMAIL_TEMPLATE_SUCCEDDED:
      var id = action.payload.id;

      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          [id]: {
            item: action.payload.template,
            fetching: false,
          },
        },
      });

    case FETCHING_EMAIL_TEMPLATE_FAILED:
      var id = action.payload.id;
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          [id]: {
            error: action.payload.error,
            fetching: false,
          },
        },
      });

    case CREATING_EMAIL_TEMPLATE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          creating: true,
          error: null,
        },
      });

    case CREATING_EMAIL_TEMPLATE_SUCCEDDED:
      var flag = action.payload.default;
      var id = action.payload.id;

      var items = state.items.map((template, index) => {
        if (template.id != id) {
          if (flag) template.default = false;
          return template;
        }
      });

      items = [action.payload, ...items];

      items = items.reduce((item, template) => {
        if (template.default) {
          return [template, ...item];
        }
        return [...item, template];
      }, []);

      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          creating: false,
          error: null,
        },
        items: items,
      });

    case CREATING_EMAIL_TEMPLATE_FAILED:
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          creating: false,
          error: action.payload,
        },
      });

    case UPDATING_EMAIL_TEMPLATE_REQUEST:
      var id = action.payload;
      var template = state.template[id] || {};
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          [id]: {
            ...template,
            updating: true,
          },
        },
      });

    case UPDATING_EMAIL_TEMPLATE_SUCCEDDED:
      var isDefault = action.payload.template.default;
      var id = action.payload.id;
      var template = action.payload.template;

      var items = state.items.map((item, index) => {
        if (item.id == id) {
          return template;
        }

        //Remove deafult flag from other templates
        if (isDefault) {
          return {
            ...item,
            default: false,
          };
        }

        return item;
      });

      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          error: null,
          [id]: {
            item: action.payload.template,
            updating: false,
          },
        },
        items: items,
      });
    case UPDATING_EMAIL_TEMPLATE_FAILED:
      var id = action.payload.id;
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          error: action.payload.error,
          [id]: {
            updating: false,
          },
        },
      });
    case DELETING_EMAIL_TEMPLATE_REQUEST:
      var id = action.payload;
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          deleting: true,
        },
      });
    case DELETING_EMAIL_TEMPLATE_SUCCEDDED:
      var id = action.payload.id;
      delete state.template[id];

      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          deleting: false,
        },
        items: state.items.filter((template, index) => {
          return template.id != id;
        }),
      });
    case DELETING_EMAIL_TEMPLATE_FAILED:
      var id = action.payload.id;
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          deleting: false,
          [id]: {
            error: action.payload.error,
          },
        },
      });

    case FETCHING_DEFAULT_EMAIL_TEMPLATE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        defaultTemplate: {
          ...state.defaultTemplate,
          loading: true,
        },
      });
    case FETCHING_DEFAULT_EMAIL_TEMPLATE_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        defaultTemplate: {
          ...state.defaultTemplate,
          item: action.payload,
          loading: false,
          error: null,
        },
      });
    case FETCHING_DEFAULT_EMAIL_TEMPLATE_FAILED:
      return Object.assign({}, state, {
        ...state,
        defaultTemplate: {
          ...state.defaultTemplate,
          loading: false,
          error: action.payload,
        },
      });

    case INVALIDATE_DEFAULT_EMAIL_TEMPLATE:
      return Object.assign({}, state, {
        ...state,
        defaultTemplate: {
          loading: false,
          item: null,
        },
      });

    case UPLOADING_MEDIA_REQUEST:
      return {
        ...state,
        template: {
          ...state.template,
          uploading: true,
          media: {
            image: [],
          },
        },
      };

    case UPLOADING_MEDIA_SUCCEEDED:
      return {
        ...state,
        item: {
          ...action.payload,
        },
        template: {
          ...state.template,
          uploading: false,
          media: {
            image: [...state.template.media.image, action.payload.image],
          },
        },
      };

    case UPLOADING_MEDIA_FAILED:
      return {
        ...state,
        template: {
          ...state.template,
          uploading: false,
          media: {
            error: action.payload.error,
          },
        },
      };

    default:
      return state;
  }
}

export { emailTemplateReducer };
